interface ShouldShowPepParams {
  isBidLoan: boolean;
  shouldSkipPep: boolean;
}

export function getShouldShowPep({
  isBidLoan,
  shouldSkipPep,
}: ShouldShowPepParams): boolean {
  return isBidLoan && !shouldSkipPep;
}
